import React from "react";
import { AgGridReact } from "@ag-grid-community/react";
import ProducerBulkUploadResponse from "./uploadProducersResponse";
import { Button } from "react-bootstrap";
import defaultGridOptions from "common/agGrid/defaultGridOptions";


export type UploadProducerSettingProps = {
    producerBulkUploadResponse: ProducerBulkUploadResponse;
    fileName: string;
    onFileRemoved: any;
};

const columnDefinitions = (props: UploadProducerSettingProps) => [
    {
        headerName: "First Name",
        field: "firstName.value",
        tooltipField: "firstName.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.firstName.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Last Name",
        field: "lastName.value",
        tooltipField: "lastName.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.lastName.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Business Name",
        field: "businessName.value",
        tooltipField: "businessName.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.businessName.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Use Business Name",
        field: "useBusinessName.value"
    },
    {
        headerName: "Account Id#",
        field: "accountIds.value",
        tooltipField: "accountIds.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.accountIds.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Account Names",
        field: "accountNames.value",
        tooltipField: "accountNames.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.accountNames.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Phone",
        field: "phone.value",
        tooltipField: "phone.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.phone.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Email",
        field: "email.value",
        tooltipField: "email.errorMessage",
        cellStyle: function (params: any) {
            if (!params.data.email.isValid) {
                return { borderColor: 'red' };
            }
        }
    },
    {
        headerName: "Postal Code",
        field: "postalCode.value"
    }
];

function isLoaded(props: UploadProducerSettingProps): boolean {
    return props.producerBulkUploadResponse != null;
}

const UploadedWithErrors = (props: UploadProducerSettingProps) => (
    <>
        {isLoaded(props) && (<div>
            <div className="row" style={{ padding: "30px 0 8px 0" }}>
                <div className="col-4 align-self-end">
                    <span className="upload-info-text">
                        File Uploaded<br></br>
                        <span className="upload-info-sub-text">
                            {props.fileName}{" "}
                            <button className="btn btn-link" onClick={props.onFileRemoved}>REMOVE FILE</button><br>
                            </br>
                            {props.producerBulkUploadResponse.totalRecords}&nbsp; records found
                 </span>
                    </span>
                </div>
                <div className="col-5 align-self-end">
                    {props.producerBulkUploadResponse.errorCount > 0 &&
                        <span className="upload-errors-text">
                            <i className="fa fa-exclamation-triangle"></i>
                            {props.producerBulkUploadResponse.errorCount} Errors found
                            <br></br>
                            <span className="upload-errors-sub-text">Please fix the errors below and try uploading the file again</span>
                        </span>
                    }
                </div>
                <div className="col-3 align-self-end" style={{ textAlign: "right" }}>
                    <Button onClick={props.onFileRemoved}>
                        <i className="fa fa-upload"></i> Upload New File
                  </Button>
                </div>
            </div>
            <div className="row">
                <div className="ag-theme-alpine" style={{ width: "100%" }} >
                    <AgGridReact
                        {...defaultGridOptions}
                        columnDefs={columnDefinitions(props)}
                        paginationPageSize={10}
                        pagination={true}
                        rowData={props.producerBulkUploadResponse.results}
                        enableBrowserTooltips={true}
                        domLayout="autoHeight"
                        onGridReady={params => params.api.sizeColumnsToFit()}
                    />
                </div>
            </div>
        </div>)}
    </>
);

export default UploadedWithErrors;
